export default "__VITE_ASSET__4e37f25a__"